export default "__VITE_ASSET__B5FXkq5p__"